import {React} from 'common'
import {Page, PageContent} from 'components/Page'
import Button from 'components/Control/Button'
import {useNavigate} from 'services/hooks'
import {useI18n} from 'store/Store'

const ContinueToLogin = ({message}) => {
    const {i18n} = useI18n()
    const navigate = useNavigate()

    return (
        <Page noHeader noDrawer>
            <PageContent>{message}</PageContent>
            <Button onClick={() => navigate('/Login')} variant="contained">
                {i18n.t('welcome.continue')}
            </Button>
        </Page>
    )
}

export default ContinueToLogin
